module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.8369/images/logos/classpass-logo.png"